import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
`;

const Title = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  p {
    color: #2d1441;
    font-family: cerapro;
    font-size: 24px;
    line-height: 29px;
    font-weight: 600;
    @media (max-width: 480px) {
      font-size: 18px;
      line-height: 18px;
    }
  }
  &:hover {
    svg {
      animation-name: rosca;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      @keyframes rosca {
        0% {
          transform: rotate(360deg) scale(1.2);
        }
        100% {
          transform: rotate(0deg) scale(1.2);
        }
      }
    }
  }
`;

const PatSeal = styled.img`
  position: absolute;
  top: -12px;
  right: -20px;
`;

const AmmountsWrapper = styled.div``;

const AmmountsDetail = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  margin-bottom: 20px;
`;

const AmmountsDebt = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const InvoiceActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const InvoiceBodyActions = styled(InvoiceActions)`
  margin: 20px 0px 10px 0px;
`;

const InvoiceDetailHeader = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  position: relative;
  border: 1px solid #bbb8bd;
  border-radius: 8px;
  padding-top: 20px;
`;

const InvoiceDetailAccordionTotal = styled.p`
  color: #2d1441;
  text-align: right;
  font-weight: 700;
  font-size: 18px;
  margin-top: 20px;
  span {
    font-weight: 500;
  }
`;

const InvoiceDetailBody = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 10px auto 0;
`;

const DueDateText = styled.p`
  color: #2d1441;
  text-align: center;
  margin-bottom: 0px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
`;

const ButtonText = styled.span`
  white-space: pre-line;
`;

export {
  Wrapper,
  Title,
  DueDateText,
  InvoiceDetailBody,
  InvoiceDetailAccordionTotal,
  InvoiceDetailHeader,
  PatSeal,
  AmmountsWrapper,
  AmmountsDetail,
  AmmountsDebt,
  InvoiceActions,
  InvoiceBodyActions,
  ButtonText,
};
